import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// custom
import TextField from "@/src/components/custom-fields/TextField";
import { HodAutocomplete as Autocomplete } from "@/src/lib/ui";

// ----------------------------------------------------------------------

RHFAutocomplete.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFAutocomplete({
  name,
  label,
  helperText,
  placeholder,
  defaultValue,
  ...other
}) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          onChange={(event, newValue) =>
            setValue(name, newValue, { shouldValidate: true })
          }
          defaultValue={defaultValue} //this is extra
          renderInput={(params) => (
            <TextField
              label={label}
              placeholder={placeholder}
              error={!!error}
              helperText={error ? error?.message : helperText}
              {...params}
            />
          )}
          {...other}
        />
      )}
    />
  );
}
